<script lang="ts">
  import { onDestroy } from "svelte";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../../../lib/mountFederatedSvelteComponent";

  export let totalOpportunities: number = 0;
  export let fullySynced: number = 0;
  export let syncInProgress: number = 0;
  export let conflicts: number = 0;
  export let errors: number = 0;

  export let onKpiClick: (detail: string) => void = () => {};

  let container: HTMLDivElement | null = null;
  let instance: any = null;
  let RemoteComponent: any = null;

  function mount() {
    if (!container) return;
    const doMount = (Component: any) => {
      instance = mountFederatedSvelteComponent(instance, Component, {
        target: container!,
        props: { totalOpportunities, fullySynced, syncInProgress, conflicts, errors },
      });
      instance.$on("kpiClick", (e: CustomEvent) => onKpiClick(e.detail));
    };
    if (RemoteComponent) doMount(RemoteComponent);
    else {
      // @ts-ignore - App2 remote
      import("App2/kpiBar")
        .then((m) => {
          RemoteComponent = m.default;
          doMount(RemoteComponent);
        })
        .catch((err) => console.warn("App2/kpiBar not available:", err));
    }
  }

  $: if (container && !instance) mount();
  $: if (instance) {
    instance.$set({ totalOpportunities, fullySynced, syncInProgress, conflicts, errors });
  }

  onDestroy(() => {
    instance = destroySvelteComponentInstance(instance);
  });
</script>

<div bind:this={container} class="w-full" data-kpi-bar-host></div>
